import React, { useMemo, useState } from 'react';

import IconedSelectorItems from '../wrappers/IconedSelectorItems.js';
import Module from '../ui_items/Module.js';
import { BackButton } from '../builder/ActionButton.js';
import SearchField from '../builder/SearchField.js';
import FloatingLayer from '../builder/FloatingLayer.js';
import SectionTitle from '../builder/SectionTitle.js';

const OrganizerSelector = (props) => {
	let url = props?.base_redirect_url ?? window.location.href;
	url = url.replace(/\/$|$/, '/');	//we enforce the URL to be ended with "/" (since we will add label.id at the end of it)

	const enable_all = props?.enable_all ?? false;
	const display_type = props?.display_type ?? 'inline';

	const available = useMemo(() => {
		let available_organizing_brands = [];
		if(enable_all) {
			available_organizing_brands.push({
				name:props?.all_label ?? "All organizing brands",
				url:(display_type != 'layer' && props.onSelect != undefined) ? `${url}all` : null,
				onClick:(display_type == 'layer' && props.onSelect != undefined) ? () => props.onSelect('all') : null,
				cta_label:props?.select_all_cta_label ?? "Select all",
				icon:'knk-go-next',
			});
		}

		props.labels.map((_label) => {
			const label = _label?.Label ?? _label;
			available_organizing_brands.push({
				...label,
				url:(display_type != 'layer' && props.onSelect == undefined) ? `${url}${label.id}` : null,
				onClick:(display_type == 'layer' && props.onSelect != undefined) ? () => props.onSelect(label.id) : null,
				cta_label:"Select",
			});
		});

		return available_organizing_brands;
	}, [props.labels]);

	const [labels, setLabels] = useState(available);
	
	const search = (k, v) => {
		setLabels((labels) => {
			return available.filter((label) => {
				let regex = new RegExp(v, 'i');
				return regex.test(label.name);
			})
		});
	};

	const goBack = () => {
		history.go(-1);
	};

	if(display_type == 'layer') {
		return (
			<FloatingLayer _class={{ size:'small' }} backButton={() => props.close()}>
				<div class="without_actions">
					<SectionTitle>{props.section_title}</SectionTitle>

					{(available.length > 10) && (
						<SearchField
							name="search"
							change={search}
							placeholder="Type to search"
							autotranslate_placeholder={false}
						/>
					)}

					<IconedSelectorItems
						items={labels}
					/>
				</div>
			</FloatingLayer>
		)
	}

	return (
		<Module
			title={{
				label:props?.section_title ?? "Select an organizing brand to proceed",
				icon:props?.title_icon ?? null,
			}}
			_class={{other:'gui_small_container'}}
			actions={<BackButton
				onClick={() => goBack()}
			/>}
		>
			{(available.length > 10) && (
				<SearchField
					name="search"
					change={search}
					placeholder="Type to search"
					autotranslate_placeholder={false}
				/>
			)}

			<IconedSelectorItems
				onSelectItem={props?.onSelectItem}
				items={labels}
				extra_classes='gui_not_in_top'
			/>
		</Module>
	);
}

export default OrganizerSelector;